/**
 * Internal dpendencies
 */
import * as actions from 'state/action-types';

export const setDateRange = (dateRange, startDate, endDate, compareType = 'previous') => ({
	type: actions.SET_DATE_RANGE,
	payload: {
		dateRange,
		startDate,
		endDate,
		compareType,
	},
});
